module.exports = __webpack_public_path__ + "media/images/visa-3e583b03029510b39da1157545c20063.png";